module.exports = __webpack_public_path__ + "img/bau-logo-for-light.b51fc06d.svg";